import moment from "moment-timezone";

export const convertDateToUserTimezone = (date, timezone) => {
  if (!date || !timezone) return null;
  return moment(date).tz(timezone).format("YYYY-MM-DD HH:mm:ss");
};

export const getDayInTimezone = (date, timezone) => {
  const m = convertDateToUserTimezone(date, timezone);
  if (!m) return null;
  return m.date();
};

export const getMonthInTimezone = (date, timezone) => {
  const m = convertDateToUserTimezone(date, timezone);
  if (!m) return null;
  return m.month() + 1;
};

export const getYearAccordingToBirthday = (dob, timezone = "UTC", birthTZ) => {
  if (!dob) return null
  const birth = moment(dob).tz(birthTZ);
  const today = moment().tz(timezone);

  const currentYear = today.year();

  const birthdayThisYear = moment.tz(
    `${currentYear}-${birth.month() + 1}-${birth.date()}`,
    "YYYY-M-D",
    timezone
  );

  if (today.isBefore(birthdayThisYear, "day")) {
    return currentYear - 1;
  }
  return currentYear;
};

export function getTargetYear({
  birthDate,
  birthTZ = "UTC",
  currentTZ,
  targetMonth,
  targetDay
}) {

  const birthMoment = moment.tz(birthDate, birthTZ);

  const now = moment.tz(currentTZ);
  const currentYear = now.year();
  targetMonth = targetMonth || now.month() + 1;
  targetDay = targetDay || birthMoment.date();

  const birthdayThisYear = moment
    .utc(birthDate)
    .tz(birthTZ)
    .year(currentYear).startOf('day')

  const targetDate = moment
    .tz(
      {
        year: currentYear,
        month: targetMonth - 1,
        day: targetDay
      },
      currentTZ
    ).startOf('day')

  const birthdayUpcoming = now.isBefore(birthdayThisYear);

  if (!birthdayUpcoming) {
    if (targetDate.isAfter(birthdayThisYear)) {
      return currentYear;
    } else {
      return currentYear + 1;
    }
  } else {
    if (targetDate.isBefore(birthdayThisYear)) {
      return currentYear;
    } else {
      return currentYear - 1;
    }
  }
}
export const getMonthAccordingToBirthdayDay = (dob, timezone, birthTZ) => {
  if (!dob || !timezone || !birthTZ) return null
  const birthDay = moment(dob).tz(birthTZ).date();
  const today = moment().tz(timezone);

  const currentMonth = today.month() + 1;
  const todayDay = today.date();

  if (todayDay < birthDay) {
    return currentMonth === 1 ? 12 : currentMonth - 1;
  }
  let nextMonth = currentMonth;
  if (nextMonth > 12) nextMonth = 1;
  return nextMonth;
};

export const getPredictionYearByMonth = (
  dob,
  targetMonth,
  targetDay = null,
  timezone = "UTC",
  birthTZ
) => {
  if (!dob) return null;

  const birth = moment(dob).tz(birthTZ);
  const today = moment().tz(timezone);

  const birthMonth = birth.month() + 1;
  const birthDay = birth.date();

  const currentMonth = today.month() + 1;
  const currentDay = today.date();

  const currentYear = today.year();

  // Use current month/day if not provided
  const m = targetMonth || currentMonth;
  const d = targetDay || currentDay;

  // Birthday date this year
  const birthdayThisYear = moment.tz(
    `${currentYear}-${birthMonth}-${birthDay}`,
    "YYYY-M-D",
    timezone
  );

  const targetDateThisYear = moment.tz(
    `${currentYear}-${m}-${d}`,
    "YYYY-M-D",
    timezone
  );

  // If target date is BEFORE birthday this year → belongs to previous birthday cycle
  if (targetDateThisYear.isBefore(birthdayThisYear, "day")) {
    return currentYear;
  }

  // After birthday → belongs to current→next cycle
  return currentYear;
};

export const getCurrentDayInTimezone = (timezone) => {
  if (!timezone) {
    return moment().date();
  }
  return moment().tz(timezone).date();
};

export const getCurrentMonthInTimezone = (timezone) => {
  if (!timezone) {
    return moment().month() + 1;
  }
  return moment().tz(timezone).month() + 1;
};

export const getCurrentYearInTimezone = (timezone) => {
  if (!timezone) {
    return moment().year();
  }
  return moment().tz(timezone).year();
};

export const convertDateToUserTimezoneWithTime = (date, timezone) => {
  if (!date || !timezone) return null;
  return moment(date)
    .tz(timezone)
    .format("MMMM DD, YYYY hh:mm A");
};


export function getPredictionRangeForYearly(birthDate, timezone) {
  if (!birthDate || !timezone) return null;
  const birth = moment.tz(birthDate, "YYYY-MM-DD", timezone);

  const birthDay = birth.date();
  const birthMonth = birth.month();
  const now = moment.tz(timezone);

  let thisYearBirthday = moment.tz(
    { year: now.year(), month: birthMonth, day: birthDay },
    timezone
  );

  let start;

  if (thisYearBirthday.isAfter(now, "day")) {
    start = thisYearBirthday.clone().subtract(1, "year");
  } else {
    start = thisYearBirthday.clone();
  }

  const end = start.clone().add(1, "year").subtract(1, "day");

  return {
    startDate: start.format("MM-DD-YYYY"),
    endDate: end.format("MM-DD-YYYY"),
  };
}

export function getPredictionRangeForMonthly(birthDate, month, year, timezone) {

  year = year || getCurrentYearInTimezone(timezone);
  year = year || getCurrentYearInTimezone(timezone);

  const birth = moment.tz(birthDate, "YYYY-MM-DD", timezone);
  const birthDay = birth.date();
  const birthMonth = birth.month();

  const start = moment.tz(
    { year, month: month - 1, day: birthDay },
    timezone
  );

  const end = start.clone().add(1, "month").subtract(1, "day");

  return {
    startDate: start.format("DD-MM-YYYY"),
    endDate: end.format("DD-MM-YYYY"),
  };
}

export function formatDate(input) {
  if (typeof input === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(input)) {
    const [month, day, year] = input.split('-');
    input = new Date(year, month - 1, day);
  }

  const date = new Date(input);

  if (isNaN(date)) return null;

  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  };

  return date.toLocaleDateString('en-GB', options);
}

export function getPredictionYear({
  birthDate,
  birthTZ,
  timezone,
  month,
  day,
}) {
  const now = moment().tz(timezone);

  const predMonth = month ?? now.month() + 1;
  const predDay = day ?? now.date();

  const bday = moment.tz(birthDate, birthTZ);
  const bMonth = bday.month() + 1;
  const bDay = bday.date();

  const currentYear = now.year();

  const isBeforeBirthday =
    predMonth < bMonth || (predMonth === bMonth && predDay < bDay);

  if (isBeforeBirthday) {
    return currentYear + 1;
  }

  return currentYear;
}

export function getPredictionYearForMonth({
  birthDate,
  birthTZ,
  timezone,
  month,
  day,
}) {
  const now = moment().tz(timezone);


  const bday = moment.tz(birthDate, birthTZ);
  const bMonth = bday.month() + 1;
  const bDay = bday.date();


  const predMonth = month ?? now.month() + 1;
  const predDay = bDay ?? now.date();

  const currentYear = now.year();

  const isBeforeBirthday =
    predMonth < bMonth || (predMonth === bMonth && predDay < bDay);

  if (isBeforeBirthday) {
    return currentYear + 1;
  }

  return currentYear;
}

export const getMonthRange = (targetYear, targetMonth, birthDay, userTimezone) => {

  const monthIndex = targetMonth - 1;

  let startDate = moment.tz(
    {
      year: targetYear,
      month: monthIndex,
      day: birthDay,
      hour: 0,
      minute: 0,
      second: 0,
    },
    userTimezone
  );

  // If invalid date (e.g., Feb 30)
  if (!startDate.isValid()) {
    startDate = moment
      .tz(
        {
          year: targetYear,
          month: monthIndex,
          day: 1,
        },
        userTimezone
      )
      .add(1, 'month')
      .startOf('day');
  }

  let endMonth;
  let endYear;

  if (birthDay === 1) {
    endMonth = targetMonth;
    endYear = targetYear;
  } else {
    endMonth = targetMonth + 1;
    endYear = targetYear;

    if (endMonth === 13) {
      endMonth = 1;
      endYear += 1;
    }
  }

  const endMonthIndex = endMonth - 1;

  const daysInEndMonth = moment
    .tz(
      {
        year: endYear,
        month: endMonthIndex,
        day: 1,
      },
      userTimezone
    )
    .daysInMonth();

  let endDay = birthDay - 1;

  // If invalid → last day of end month
  if (endDay <= 0 || endDay > daysInEndMonth) {
    endDay = daysInEndMonth;
  }

  const endDate = moment.tz(
    {
      year: endYear,
      month: endMonthIndex,
      day: endDay,
      hour: 23,
      minute: 59,
      second: 59,
    },
    userTimezone
  );

  return {
    startUTC: startDate.clone().utc(),
    endUTC: endDate.clone().utc(),
  };
}
